import { useParams } from "react-router-dom";
import InfoChip from "../components/common/InfoChip";
import { Severity } from "../types";
import { useFetchAdDetailsQuery, useUpdateAdMutation } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import { adminSchema, editAdSchema } from "../configs/validations";
import AdForm from "../forms/Ad.form";

const EditAdWrapper = () => {
  const { adId } = useParams();

  if (!adId)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="Bannière introuvable"
      />
    );

  return <EditAd adId={adId} />;
};

interface EditAdProps {
  adId: string;
}

const EditAd: React.FC<EditAdProps> = ({ adId }) => {
  const [updateAd, { isLoading }] = useUpdateAdMutation();
  const { data: adDetails, isFetching } = useFetchAdDetailsQuery(adId);

  if (isLoading || isFetching) return <div>Chargement...</div>;

  if (!adDetails)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="bannière introuvable"
      />
    );

  return (
    <div className="w-full flex flex-col items-center p-4">
      <AdForm
        initialValues={{
          cities: adDetails.cities.map((city) => city._id),
          previewPath: adDetails.imagePath,
        }}
        validationSchema={editAdSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          const result = await updateAd({
            adId,
            body: values,
          });

          if (!result.error) {
            showToast("Bannière mis à jour avec succès", ToastType.SUCCESS);
            resetForm();
          }
        }}
      />
    </div>
  );
};

export default EditAdWrapper;
